import { api } from "@/lib/api";
import { API } from "@/config";
import type { MontageAspectRatio } from "@/lib/montageApi";

export type MusicJobStatus = "PROCESSING" | "READY" | "ERRORE";

export interface MusicJob {
  id: string;
  status: MusicJobStatus;
  phase: "queued" | "encoding" | "storing" | null;
  error: string | null;
  aspect_ratio: MontageAspectRatio;
  image_name: string;
  audio_name: string;
  duration: number;
  has_video: boolean;
  created_at: string;
  completed_at: string | null;
}

export interface MusicLimits {
  max_image_bytes: number;
  max_audio_bytes: number;
  max_audio_seconds: number;
}

export const MUSIC_CLIENT_TIMEOUT_MS = 20 * 60 * 1000;

export const getMusicLimits = () => api.get<MusicLimits>("/music/limits").then((r) => r.data);
export const listMusicJobs = () => api.get<MusicJob[]>("/music/jobs").then((r) => r.data);
export const getMusicJob = (id: string) => api.get<MusicJob>(`/music/jobs/${id}`).then((r) => r.data);
export const deleteMusicJob = (id: string) => api.delete(`/music/jobs/${id}`).then((r) => r.data);
export const musicVideoUrl = (id: string) => `${API}/music/jobs/${id}/video`;
export const musicDownloadUrl = (id: string) => `${API}/music/jobs/${id}/video?download=true`;

export const createMusicJob = (
  image: File,
  audio: File,
  aspectRatio: MontageAspectRatio,
  onUploadPct: (pct: number) => void,
) => {
  const fd = new FormData();
  fd.append("image", image);
  fd.append("audio", audio);
  fd.append("aspect_ratio", aspectRatio);
  return api
    .post<MusicJob>("/music/jobs", fd, {
      onUploadProgress: (e) => onUploadPct(e.total ? Math.round((e.loaded / e.total) * 100) : 0),
    })
    .then((r) => r.data);
};
